import React from "react";

const Loader = () => {
  return (
    <div className="flex justify-center items-center min-h-[150px] relative">
      <div className="w-24 h-1 bg-blue-500 animate-slide"></div>
      
      <style>
        {`
          @keyframes slide {
            0% { transform: translateX(-50px); opacity: 0.3; }
            50% { opacity: 1; }
            100% { transform: translateX(50px); opacity: 0.3; }
          }
          .animate-slide {
            animation: slide 1.5s infinite alternate ease-in-out;
          }
        `}
      </style>
    </div>
  );
};

export default Loader;
